export default function Classficator(name) {
  switch (name) {
    case "modelDevelopment":
      return "Model Development";
    case "constructionMethodology":
      return "Construction Methodology";
    case "methodologyDeveloping":
      return "Developing";
    case "methodologyVerifying":
      return "Verifying";
    case "methodologyCommunicate":
      return "Communicate";
    case "methodologyBuildingBridge":
      return "Bridge";
    case "methodologyBuildingRoad":
      return "Road";
    case "methodologyBuildingRW":
      return "Retaining Wall";
    case "methodologyBuildingDrainage":
      return "Drainage";
    case "methodologyBuildingMSB":
      return "Multi-Storey Building";
    case "methodologyPhaseConcept":
      return "Concept";
    case "methodologyPhaseTender":
      return "Tender";
    case "methodologyPhaseECI":
      return "ECI";
    case "methodologyPhaseConstruction":
      return "Construction";
    case "methodologyOutputsTD":
      return "Technical Drawing";
    case "methodologyOutputsRD":
      return "Rendered Drawing";
    case "methodologyOutputsFWD":
      return "Figures for written documents";
    case "methodologyOutputsAnimations":
      return "Animations";
    case "methodologyOutputsSimulations":
      return "Simulations";
    case "modelTemporaryWorks":
      return "Temporary Works";
    case "modelPermanentWorks":
      return "Permanent Works";
    case "modelEquipment":
      return "Equipment";
    case "modelConcept":
      return "Concept";
    case "modelTender":
      return "Tender";
    case "modelECI":
      return "ECI";
    case "modelConstruction":
      return "Construction";
    case "modelTypeBridge":
      return "Bridge";
    case "modelTypeRoad":
      return "Road";
    case "modelTypeRW":
      return "Retaining Wall";
    case "modelTypeDrainage":
      return "Drainage";
    case "modelTypeMSB":
      return "Multi-Storey Building";
    case "modelExcavator":
      return "Excavator";
    case "modelPilingRig":
      return "Piling Rig";
    case "modelTBM":
      return "TBM";
    case "modelCrane":
      return "Crane";
    case "modelUsageDeveloping":
      return "Developing";
    case "modelUsageVerifying":
      return "Verifying";
    case "modelUsageCommunicate":
      return "Communicate";
    case "modelUsageFabrication":
      return "Fabrication";
    case "modelUsageQuantities":
      return "Quantities";
    default:
      return name;
  }
}
